import axios from "axios";
import { useState } from "react";
import Navbar from "../../components/navbar/Navbar";
import { useNavigate } from "react-router-dom";

const Login = () => {

    let navigate = useNavigate() 
  const [email, sstEmail] = useState("");
  const [password, sstPassword] = useState("");

  const getUser = async () => {
    try {
      // eslint-disable-next-line no-unused-vars
      const res = await axios.post(process.env.REACT_APP_API_URL + "/auth/login", { email, password })
        .then((user) => {
          localStorage.setItem('user', JSON.stringify(user.data));
          navigate("/")
        });
    } catch (error) {
        console.log(error);
    }
  };

  const loginStyle = { height: "calc(100vh - 56px)" };
  return (
    <>
      <Navbar />
      <div
        style={loginStyle}
        className="login w-full flex bg-gray-200 justify-center"
      >
        <div className="card p-4 bg-white self-center w-96 flex flex-col items-center gap-6 rounded-md drop-shadow-md">
          <div className="flex flex-col items-center gap-2">
            <h1 className="text-gray-800 text-lg drop-shadow font-Roboto font-semibold">
              login
            </h1>
            <p className="text-gray-400 text-sm drop-shadow font-Roboto font-semibold">
              Do not have account
              <span className="text-gray-600 cursor-pointer hover:text-gray-700">
                {" "}
                singUp
              </span>
            </p>
          </div>
          <div className="flex flex-col gap-4 w-full">
            <input
              onChange={(e) => sstEmail(e.target.value)}
              className="p-2 text-gray-600 bg-gray-100 outline-primary font-Roboto font-normal w-full"
              type="email"
              name="email"
              placeholder="Enter your email."
            />
            <input
              onChange={(e) => sstPassword(e.target.value)}
              className="p-2 text-gray-600 bg-gray-100 outline-primary font-Roboto font-normal w-full"
              type="password"
              name="password"
              placeholder="enter your password."
            />
          </div>
          <button onClick={() => getUser()}
          className="py-2 px-5 text-white text-base drop-shadow bg-primary hover:bg-primary-200 cursor-pointer transition font-Roboto font-semibold rounded-md">
            Login
          </button>
        </div>
      </div>
    </>
  );
};

export default Login;
